import React from 'react'

// Header skeleton (title + subtitle)
const CatchUpHeaderSkeleton = () => (
    <div className="catch-up-header-container animate-pulse mb-6">
        <div className="catch-up-titles w-full">
            <div className="h-10 w-60 bg-[#d6d6e7] rounded mb-3"></div>
            <div className="h-5 w-80 bg-[#e4e4f2] rounded"></div>
        </div>
    </div>
)

// Mode switch skeleton (Unseen/Archive buttons)
const CatchUpModeSkeleton = () => (
    <div className="flex flex-row w-full mt-[20px] gap-5 animate-pulse">
        <div className="catch-up-mode-button bg-[#e4e4f2] h-[50px] w-40 rounded"></div>
        <div className="catch-up-mode-button bg-[#e4e4f2] h-[50px] w-40 rounded"></div>
    </div>
)

// Search bar skeleton
const CatchUpSearchSkeleton = () => (
    <div className="flex flex-row items-center my-[20px] w-full animate-pulse">
        <div className="catch-up-search-container w-[350px] h-[50px] bg-[#f1f1fa] rounded-[144px]"></div>
    </div>
)

// Filter bar skeleton (years/classes/filter button)
const CatchUpFilterSkeleton = () => (
    <div className="flex flex-col w-full gap-2 animate-pulse">
        <div className="flex flex-row gap-3">
            <div className="h-10 w-24 bg-[#e4e4f2] rounded-full"></div>
            <div className="h-10 w-24 bg-[#e4e4f2] rounded-full"></div>
            <div className="h-10 w-24 bg-[#e4e4f2] rounded-full"></div>
        </div>
        <div className="flex flex-row gap-3">
            <div className="h-10 w-24 bg-[#e4e4f2] rounded-full"></div>
            <div className="h-10 w-24 bg-[#e4e4f2] rounded-full"></div>
        </div>
        <div className="flex flex-row gap-3 mt-3">
            <div className="h-10 w-32 bg-[#e4e4f2] rounded-full"></div>
        </div>
    </div>
)

// Single catch-up item skeleton
export const CatchUpItemSkeleton = () => (
    <div className="bg-white w-full h-full min-h-[127px] flex flex-col animate-pulse mb-4 p-6 rounded-lg">
        <div className="flex flex-row items-center gap-3">
            <div className="w-[35px] h-[35px] bg-[#e4e4f2] rounded-full"></div>
            <div className="h-5 w-32 bg-[#e4e4f2] rounded"></div>
            <div className="h-4 w-20 bg-[#e4e4f2] rounded"></div>
            <span className="flex-1"></span>
            <div className="h-4 w-16 bg-[#e4e4f2] rounded"></div>
        </div>
        <div className="flex flex-row items-end gap-2">
            <div className="h-4 w-60 bg-[#e4e4f2] rounded"></div>
            <div className="h-8 w-28 bg-[#e4e4f2] rounded-full ml-auto"></div>
        </div>
    </div>
)

const CatchUpSkeleton = () => (
    <div className="catch-up-container bg-[#ECEBF8]" id="scroll-inf-target">
        <div className="catch-up-inner-container">
            <CatchUpHeaderSkeleton />
            <CatchUpModeSkeleton />
            <CatchUpSearchSkeleton />
            <CatchUpFilterSkeleton />
            <div className="catch-up-list w-full mt-6">
                {[...Array(4)].map((_, idx) => (
                    <CatchUpItemSkeleton key={idx} />
                ))}
            </div>
        </div>
    </div>
)

export default CatchUpSkeleton
